import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/** @jsx jsx */


import { jsx, Box, Flex } from 'theme-ui';
import React from 'react';
import { Context, useDeck } from './context';
import modes from './modes';
import Header from './header';
import Footer from './footer';
import Slide from './slide';
import Clock from './clock';
import Timer from './timer';
import { jsx as ___EmotionJSX } from "@emotion/core";

var Main = function Main(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100vw' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '100vh' : _ref$height,
      _ref$preview = _ref.preview,
      preview = _ref$preview === void 0 ? false : _ref$preview,
      props = _objectWithoutPropertiesLoose(_ref, ["width", "height", "preview"]);

  var outer = useDeck();

  var context = _objectSpread(_objectSpread({}, outer), {}, {
    main: !preview
  });

  return jsx(Context.Provider, {
    value: context
  }, jsx("div", {
    sx: {
      width: width,
      height: height,
      position: 'relative',
      overflow: 'hidden'
    }
  }, props.header && jsx(Header, null, props.header), props.children, props.footer && jsx(Footer, null, props.footer)));
};

var Presenter = function Presenter(props) {
  var next = props.slides[props.index + 1];
  return jsx("div", {
    sx: {
      display: 'flex',
      height: '100vh',
      color: 'white',
      bg: 'backdrop'
    }
  }, jsx("div", {
    sx: {
      width: '60%',
      height: '100vh',
      padding: 3
    }
  }, jsx(Main, _extends({}, props, {
    width: "100%",
    height: "100%"
  }), jsx(Slide, null, props.slide))), jsx(Flex, {
    sx: {
      flexDirection: 'column',
      width: '40%',
      height: '100vh',
      py: 3,
      pr: 3,
      overflowY: 'auto'
    }
  }, jsx(Slide, {
    width: "100%",
    height: "100vh",
    zoom: 1 / 2,
    sx: {}
  }, next), jsx("div", {
    sx: {
      py: 3,
      flex: '1 1 auto'
    }
  }, props.notes), jsx(Flex, {
    sx: {
      alignItems: 'baseline',
      fontFamily: '"Roboto Mono", Menlo, monospace'
    }
  }, jsx(Box, null, props.index, " / ", props.slides.length - 1), jsx("a", {
    href: "/",
    target: "_blank",
    title: "Open in new window",
    sx: {
      ml: 3,
      fontWeight: 'bold',
      color: 'inherit',
      textDecoration: 'none'
    }
  }, "\u2B08"), jsx(Box, {
    mx: "auto"
  }), jsx(Box, null, jsx(Timer, null), ' ', jsx(Clock, null)))));
};

var Overview = function Overview(props) {
  var ref = React.useRef(null);
  React.useEffect(function () {
    if (!ref.current) return;
    if (typeof ref.current.scrollIntoViewIfNeeded !== 'function') return;
    ref.current.scrollIntoViewIfNeeded();
  }, [ref.current]);
  return jsx("div", {
    sx: {
      display: 'flex',
      height: '100vh',
      color: 'white',
      bg: 'backdrop'
    }
  }, jsx("div", {
    sx: {
      width: '25%',
      height: '100vh',
      overflowY: 'auto',
      p: 2
    }
  }, props.slides.map(function (slide, i) {
    return jsx("div", {
      key: i,
      ref: i === props.index ? ref : null,
      role: "button",
      title: "Go to slide " + i,
      onClick: function onClick(e) {
        props.setIndex(i);
        props.setStep(0);
        props.setSteps(0);
      },
      sx: {
        p: 2,
        height: '30%'
      }
    }, jsx(Slide, {
      sx: {
        outline: props.index === i ? '2px solid cyan' : null
      },
      zoom: 1 / 4
    }, slide));
  })), jsx("div", {
    sx: {
      width: '75%',
      py: 3,
      pr: 3,
      pl: 2
    }
  }, jsx(Main, _extends({}, props, {
    width: "100%",
    height: "100%"
  }), jsx(Slide, {
    zoom: 3 / 4
  }, props.slide))));
};

var Grid = function Grid(props) {
  var ref = React.useRef(null);
  React.useEffect(function () {
    if (!ref.current) return;
    if (typeof ref.current.scrollIntoViewIfNeeded !== 'function') return;
    ref.current.scrollIntoViewIfNeeded();
  }, [ref.current]);
  return jsx("div", {
    sx: {
      minHeight: '100vh',
      color: 'white',
      bg: 'backdrop'
    }
  }, jsx("div", {
    sx: {
      display: 'flex',
      alignItems: 'flex-start',
      flexWrap: 'wrap'
    }
  }, props.slides.map(function (slide, i) {
    return jsx("div", {
      key: i,
      ref: i === props.index ? ref : null,
      role: "button",
      title: "Go to slide " + i,
      onClick: function onClick(e) {
        props.setIndex(i);
        props.setStep(0);
        props.setSteps(0);
        props.setMode(modes.default);
      },
      sx: {
        p: 2,
        width: '25%',
        height: '23vh'
      }
    }, jsx(Slide, {
      sx: {
        outline: props.index === i ? '2px solid cyan' : null
      },
      zoom: 1 / 4
    }, slide));
  })));
};

var Print = function Print(props) {
  return jsx(React.Fragment, null, props.slides.map(function (slide, i) {
    return jsx(Main, {
      key: i,
      preview: true
    }, jsx(Slide, null, slide));
  }));
};

export default (function (props) {
  var context = useDeck();

  switch (context.mode) {
    case modes.presenter:
      return jsx(Presenter, _extends({}, props, context));

    case modes.overview:
      return jsx(Overview, _extends({}, props, context));

    case modes.grid:
      return jsx(Grid, _extends({}, props, context));

    case modes.print:
      return jsx(Print, _extends({}, props, context));

    case modes.default:
    default:
      return jsx(Main, _extends({}, props, context));
  }
});